import { getFileExtensionByMimeType, mimeType } from '@/constants/fileMimeType'

export const urlToFile = async url => {
  try {
    const response = await fetch(url)
    const blob = await response.blob()

    return new File([blob], `file${getFileExtensionByMimeType(blob.type)}`, { type: blob.type })
  } catch (e) {
    return null
  }
}

export const base64ToFile = (base64String, sliceSize = 512) => {
  const arr = base64String.split(',')
  const b64Data = arr[arr.length - 1]
  const byteCharacters = Buffer.from(b64Data, 'base64').toString('binary')
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)

    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }

  const fileExtension = getFileExtensionByBase64(b64Data)

  return new File(byteArrays, `file${fileExtension}`, { type: mimeType[fileExtension] })
}

const getFileExtensionByBase64 = base64String => {
  // Code: https://stackoverflow.com/questions/24034951/checking-file-type-from-base64/41219153#41219153
  // Explanation: https://stackoverflow.com/questions/62329321/how-can-i-check-a-base64-string-is-a-filewhat-type-or-not/62330081#62330081
  switch (base64String.substring(0, 5).toUpperCase()) {
    case 'IVBOR':
      return '.png'
    case '/9J/4':
      return '.jpg'
    case 'JVBER':
      return '.pdf'
    case 'U1PKC':
      return '.txt'
    default:
      return ''
  }
}
